import { createContext, useContext } from "react";
import type { PayrollItem, PayrollRun } from "../types/payroll.types";

interface PayrollRunDetailContextType {
  run: PayrollRun | null;
  refetch: () => Promise<void>;
  lineItems: PayrollItem[];
  totals: { employees: number; gross: number; net: number };
}

const PayrollRunDetailContext =
  createContext<PayrollRunDetailContextType | null>(null);

export const usePayrollRunDetail = () => {
  const context = useContext(PayrollRunDetailContext);
  if (!context) {
    throw new Error("usePayrollRunDetail must be used within provider");
  }
  return context;
};

export default PayrollRunDetailContext;
